export default __webpack_public_path__ + "static/040-0f4c937360c2e5157c92b0dbdfab73ae.jpg";